import { COMPANY } from "./links";

export const REFUNDS = {
  slug: "cancellation-refund-policy",
  title: "Cancellation & Refund Policy",
  seoTitle: "Cancellation & Refund Policy | Marioway Benefits Consultancy Ltd",
  description: "Cancellation rights, refunds and how fees are treated for work not started, work in progress and completed work at Marioway Benefits Consultancy Ltd.",
  intro: `This policy explains how cancellations and refunds work for services provided by ${COMPANY.name}. It is designed to respect your rights under the Consumer Contracts (Information, Cancellation and Additional Charges) Regulations 2013 and the Consumer Rights Act 2015. It forms part of our Terms & Conditions.`,
  summaryRo: {
    title: "Pe scurt, în română",
    items: [
      "14 zile de răzgândire: dacă am convenit serviciul la distanță (telefon, WhatsApp, e-mail), poți anula în 14 zile fără motiv – scrie-ne clar că vrei să anulezi.",
      "Lucrul nu a început: primești înapoi toți banii/avansul, în 14 zile.",
      "Lucrul a început la cererea ta: plătești doar partea deja făcută; restul se returnează.",
      "Lucrul e finalizat: onorariul este datorat integral și nu se returnează, pentru că serviciul a fost prestat – chiar dacă instituția refuză cererea.",
      "Taxe către stat/terți (cereri, DBS, certificate, curier): nu se returnează de către Marioway.",
      "Servicii lunare (contabilitate, salarii): se pot opri cu preaviz de o lună, în scris.",
      "Dacă munca nu a fost făcută cu grijă și competență rezonabile, ai drepturi conform Consumer Rights Act 2015 – spune-ne și rezolvăm.",
    ],
  },
  sections: [
    {
      h: "1. Your 14-day right to cancel",
      list: [
        "Where you are a consumer and we agree the service at a distance (telephone, WhatsApp, e-mail, online) or away from our premises, you have 14 days from the day the contract is made to cancel without giving a reason.",
        `To cancel, simply tell us clearly in writing — e-mail ${COMPANY.email} or WhatsApp ${COMPANY.phone} — before the 14 days end. You may use the words: "I wish to cancel my contract for [service] agreed on [date]."`,
        "If you cancel within the 14 days and we have not started work at your request, we will refund any payment or deposit in full within 14 days of your cancellation, using the same payment method where possible.",
      ],
    },
    {
      h: "2. Urgent work started during the cancellation period",
      list: [
        "Many of our clients have deadlines and ask us to start straight away. If you ask us to begin work within the 14-day period, you agree that we may do so.",
        "If you then cancel before the work is complete, you will pay a proportionate amount for the work carried out up to the point you told us you wanted to cancel, and we will refund the balance of any payment made.",
        "If the work is fully completed within the 14-day period at your express request, you lose the right to cancel that work and the full fee is payable.",
      ],
    },
    {
      h: "3. Work not yet started",
      p: ["Where we have agreed a service and you cancel before we have started any work (whether inside or outside the 14-day period), we will refund any deposit or payment in full, less any third-party costs we have already incurred on your instruction and cannot recover."],
    },
    {
      h: "4. Work already started at your request",
      p: ["Where work has started at your request and you cancel, we charge a fair proportion of the agreed fee that reflects the work done (for example time spent, documents prepared, forms completed). We will explain the calculation in writing and refund any balance within 14 days."],
    },
    {
      h: "5. Completed work",
      list: [
        "Once the agreed work has been completed (for example a form prepared and submitted, documents organised and delivered, a letter drafted), the full fee is payable and is non-refundable, because the service has been provided.",
        "Our fee is for the administrative work performed. It is not dependent on the decision of any government body or third party, and no refund is due because an application is refused, delayed or decided differently from what you hoped.",
        "If you believe the work was not carried out with reasonable care and skill, please contact us — you may be entitled to a repeat performance or a price reduction under the Consumer Rights Act 2015, and you can use our Complaints Policy.",
      ],
    },
    {
      h: "6. Government and third-party charges",
      p: ["Fees paid to government bodies or third parties (for example application fees, DBS fees, certificate fees, courier costs, payment-provider charges) are outside our control and are non-refundable by Marioway once paid. Any refund of such fees is subject to the rules of the organisation concerned."],
    },
    {
      h: "7. Deposits",
      list: [
        "A deposit may be requested and is agreed in writing before work begins. Deposits are applied against the final fee.",
        "Deposits are refundable in full if you cancel before work starts (subject to section 3), and proportionately where work has started (section 4). Deposits are not refundable once the work is complete.",
      ],
    },
    {
      h: "8. Monthly or ongoing administration services",
      list: [
        "For ongoing services (for example monthly bookkeeping or payroll administration), either party may end the arrangement by giving at least one month's written notice, unless a different notice period has been agreed in writing.",
        "Fees for the current period remain payable. Fees paid in advance for periods after the notice period ends will be refunded.",
      ],
    },
    {
      h: "9. Cancellation by Marioway",
      p: ["If we need to cancel a service (for example because we cannot carry out the work, or because the service requires regulated advice that we are not authorised to provide), we will tell you as soon as possible and refund any payment for work not carried out."],
    },
    {
      h: "10. How refunds are paid",
      p: [`Refunds are made within 14 days of the cancellation being agreed, normally to the original payment method. If you have any questions about this policy, contact ${COMPANY.email}. Last updated: ${COMPANY.updated}.`],
    },
  ],
};
